export default function AppFooter() {
  return (
    <footer className="max-w-[1400px] mx-auto px-4 sm:px-6 py-6 text-center">
      <p className="text-xs sm:text-sm text-white/55">
        Copyright 2026{" "}
        <a
          href="https://visiontrek.in"
          target="_blank"
          rel="noopener noreferrer"
          className="font-semibold text-cyan-200 hover:text-white transition-colors"
        >
          Visiontrek Communications
        </a>
        . All rights reserved.
      </p>
    </footer>
  );
}
